import { useTranslation } from 'react-i18next'
import { useProductData } from '@/components/ProductData/ProductDataProvider'
import { MAX_SCORE } from '@/features/memberReviews/memberReviews.constants'
import { useProductReviewsMetadata } from '@/features/memberReviews/ProductReviewsMetadataProvider'
import { Button } from 'ui/src/components/Button/Button'
import { yStack } from 'ui/src/patterns/stack'
import { AverageRating } from './AverageRating'
import { PillowHeader } from './PillowHeader'
import { ReviewsDialog } from './ReviewsDialog'
import { ReviewsDisclaimer } from './ReviewsDisclaimer'
import { ReviewsDistributionByScore } from './ReviewsDistributionByScore'
import { disclaimerText, reviewsDistributionWrapper, wrapper } from './ProductReviews.css'

export type ProductReviewsProps = { showReviewComments?: boolean }

export const ProductReviews = ({ showReviewComments = true }: ProductReviewsProps) => {
  const { t } = useTranslation('reviews')

  const { name: productId, displayNameFull: productName, pillowImage } = useProductData()
  const productReviewsMetadata = useProductReviewsMetadata()

  if (!productReviewsMetadata) {
    console.warn('ProductReviews | No product reviews metadata available')
    return null
  }

  const { averageRating, reviewsDistribution } = productReviewsMetadata

  return (
    <div className={wrapper}>
      <section>
        <AverageRating as="h3" score={averageRating.score} maxScore={MAX_SCORE} />
        <ReviewsDisclaimer
          className={disclaimerText}
          size={{ _: 'xs', sm: 'md' }}
          reviewsCount={averageRating.totalOfReviews}
        />
      </section>

      <div className={yStack({ gap: 'xl', alignItems: 'center' })}>
        <div className={reviewsDistributionWrapper}>
          {reviewsDistribution.map(([score, percentage]) => (
            <ReviewsDistributionByScore key={score} score={score} percentage={percentage} />
          ))}
        </div>

        {showReviewComments && (
          <ReviewsDialog
            productIds={[productId]}
            Header={
              <PillowHeader
                title={productName}
                score={averageRating.score}
                reviewsCount={averageRating.totalOfReviews}
                pillow={pillowImage}
              />
            }
            reviewsDistribution={reviewsDistribution}
          >
            <Button variant="primary-alt" size="medium">
              {t('VIEW_REVIEWS_LABEL')}
            </Button>
          </ReviewsDialog>
        )}
      </div>
    </div>
  )
}
